<template>
  <div class="rankList">
    <div class="title">
      <img src="../assets/image/paihangbang@2x.png">
    </div>
    <div style="position: relative;top: -1.733333333vw;">
      <div class="rank" v-for="(item,index) in ranklist" :key="index">
        <div class="leftbar">
          <span class="no">第{{ index+1 }}名</span><span class="tit">{{ item.name }}</span>
        </div>
        <div class="no">{{ item.praise }}票</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RankList',
    props: ['ranklist']
  }
</script>

<style lang="scss" scoped>
.rankList {
  width: 92vw;
  min-height: 95.466666667vw;
  background: white;
  margin: 0 auto;
  border-radius: 2.6666667vw;
  padding: 0px 15px 0px 20px;
  .title {
    width: 61.06666666666667vw;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
  .rank {
    height: 13.066666667vw;
    // line-height: 35px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    border-bottom: 1px solid #DCDCDC;
    .leftbar {
      width:70%;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      height: 13.066666667vw;
      line-height: 19.066667vw;
    }
    .no {
      height: 13.066666667vw;
      color: #5BB377;
      font-size: 16px;
      line-height: 19.066667vw;
    }
    .tit {
      font-size: 16px;
      margin-left: 10px;   
      color: #433F3D;
    }
  }
}
</style>